export enum DRAWER_POSITION {
    LC = "LC",
    RC = "RC",
}

export const DRAWER_BUTTON_ELEMENT_NAME = {
    reviews: "REVIEWS_DRAWER_BUTTON",
    rewards: "REWARDS_DRAWER_BUTTON",
    wishlist: "WISHLIST_DRAWER_BUTTON",
} as const;
